import React, { useEffect, useState } from "react";
import "./Header.css";
import { FaFacebook, FaInstagram, FaTwitter, FaTiktok, FaYoutube, FaMapMarkedAlt } from "react-icons/fa";
import { FiInfo, FiShare2 } from "react-icons/fi";
import { configShop } from '../../states/configShop';
import Modal from "../Modal/modal";
import useWindowWidth from "../hooks/useMediaQuery";
import AddressAdd from "../Address/AddressAdd";
import InfoShop from "../info/info";
const Header = ({ properties }) => {
    const width = useWindowWidth()
    const [copied, setCopied] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const { dataConfig } = configShop();
    const abierto = properties.status ?? false;
    const handleShare = async () => {
        const url = window.location.href; // URL actual
        if (navigator.share) {
            try {
                await navigator.share({
                    title: dataConfig?.title_home,
                    text: dataConfig?.description_home,
                    url: url,
                });
                console.log("Compartido con éxito");
            } catch (error) {
                console.log("Error al compartir:", error);
            }
        } else if (navigator.clipboard) {
            // Fallback: copiar al portapapeles
            navigator.clipboard.writeText(url).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // mensaje temporal
            });
        } else {
            alert("Tu navegador no soporta compartir");
        }
    };


    return (
        <header className="container" style={{ color: '#000000' }}>
            <div className="container-fluid w-100">
                <div className="row align-items-center  header-container">
                    {/* Columna 1: Logo */}
                    <div className="col-3 col-lg-2 text-center text-lg-start mb-2 mb-lg-0">
                        <div
                            className="header-logo"
                            style={{ backgroundImage: `url(${dataConfig?.page_menu?.logo_image})` }}
                            role="img"
                            aria-label="Logo"
                        />
                    </div>

                    {/* Columna 2: Nombre y dataConfig.social */}
                    <div className="col-9 col-lg-7 text-left mb-2 mb-lg-0">
                        <h2 className="restaurant-name mb-1 color-text" style={{ "--btn-font-color": dataConfig?.page_menu?.color_text_nav_bars }}>
                            {properties.company_name}
                            <FiInfo onClick={() => setOpenModal(true)} color={dataConfig?.page_menu?.color_text_nav_bars} size={25} className="mx-1" />
                            <FiShare2 onClick={() => handleShare()} color={dataConfig?.page_menu?.color_text_nav_bars} size={25} className="mx-1" />
                        </h2>
                        <div className="social-icons my-1">
                            {dataConfig?.social?.instragram && (

                                <a
                                    href={`https://www.instagram.com/${dataConfig.social.instragram}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FaInstagram color={dataConfig?.page_menu?.color_social_networks} size={20} className="mx-1" />
                                </a>
                            )}

                            {dataConfig?.social?.facebook && (
                                <a
                                    href={`https://www.facebook.com/${dataConfig.social.facebook}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FaFacebook color={dataConfig?.page_menu?.color_social_networks} size={20} className="mx-1" />
                                </a>
                            )}

                            {dataConfig?.social?.tiktok && (
                                <a
                                    href={`https://www.tiktok.com/@${dataConfig.social.tiktok}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FaTiktok color={dataConfig?.page_menu?.color_social_networks} size={20} className="mx-1" />
                                </a>
                            )}

                            {dataConfig?.social?.twiter && (
                                <a
                                    href={`https://twitter.com/${dataConfig.social.twiter}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FaTwitter color={dataConfig?.page_menu?.color_social_networks} size={20} className="mx-1" />
                                </a>
                            )}

                            {dataConfig?.social?.youtube && (
                                <a
                                    href={`https://www.youtube.com/${dataConfig.social.youtube}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FaYoutube color={dataConfig?.page_menu?.color_social_networks} size={20} className="mx-1" />
                                </a>
                            )}
                        </div>
                        <div className="social-icons my-1">
                            {dataConfig?.branch?.point && (

                                <button
                                    onClick={() => window.open(dataConfig?.branch?.point, "_blank")}
                                    className="boton-home-v3" style={{ "--btn-color": dataConfig?.page_menu?.button?.color, "--btn-text-color": dataConfig?.page_menu?.button?.color_text }}>
                                    <p className="boton-title-v3"> <FaMapMarkedAlt color={dataConfig?.page_menu?.button?.color_text} size={20} className="mx-1" /> Quiero llegar</p>
                                </button>

                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openModal}
                onClick={() => setOpenModal(false)}
                title={""}
            >
                <InfoShop
                    setOpenModal={setOpenModal}
                />
            </Modal>

        </header>
    );
};

export default Header;
